
var count = 
{
counter: 0
}

export default count;